/**************************************************
 * Nombre:       Tarjeta_Img_Detalle
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton} from "@mui/material";
import {useEffect, useState} from "react";
import {Add} from '@mui/icons-material'
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Img_Detalle = ({img, imgs}) => {
    const {sCell} = useResponsive()
    const [ver, setVer] = useState(false)
    const [open, setOpen] = useState(false);
    const [imgsVer, setImgsVer] = useState([]);


    function reorganizarArray(array, index) {
        // Validación por si el índice está fuera de rango o el array está vacío
        if (index < 0 || index >= array.length) {
            return array;
        }

        // Cortamos desde el índice elegido hasta el final
        const parteFinal = array.slice(index);

        // Cortamos desde el principio hasta el índice elegido (sin incluirlo)
        const parteInicial = array.slice(0, index);

        // Unimos ambas partes: la final pasa a ser la primera
        return [...parteFinal, ...parteInicial];
    }

    useEffect(() => {

        let index = imgs.indexOf(img);
        setImgsVer(reorganizarArray(imgs, index));

    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            onMouseLeave={() => setVer(false)}
            onMouseEnter={() => setVer(true)}
            sx={{
                backgroundImage: 'url(' + img + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                p: 2,
                transition: "all .2s ease-in-out"
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-end', mb: 60, transition: "all .2s ease-in-out"}}>
                <IconButton
                    onClick={() => setOpen(!open)}
                    sx={{
                        backgroundColor: '#ffffff90',
                        borderRadius: 0,
                        transition: "all .2s ease-in-out",
                        opacity: sCell || ver ? 1 : 0
                    }}>
                    <Add/>
                </IconButton>
            </Grid>

            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={imgsVer.map((it) => {
                    return {src: it}
                })
                }
            />

        </Grid>
    )

}
export default Tarjeta_Img_Detalle